import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TrackerService } from 'src/app/shared/util/tracker.service';
import { environment } from 'src/environments/environment';

export interface FeatureItem {
  icon: string;
  titleKey: string;
  textKey: string;
}

export interface RelatedLink {
  route: string;
  icon: string;
  titleKey: string;
  textKey: string;
}

export interface KpiSample {
  labelKey: string;
  value: string;
}

@Component({
  selector: 'app-management-tool',
  templateUrl: './management-tool.component.html',
  styleUrls: ['./management-tool.component.scss'],
})
export class ManagementToolComponent implements OnInit {
  assistantHref = '';

  readonly features: FeatureItem[] = [
    { icon: 'lni-home', titleKey: 'MANAGEMENT_TOOL.FEATURE_1_TITLE', textKey: 'MANAGEMENT_TOOL.FEATURE_1_TEXT' },
    { icon: 'lni-grow', titleKey: 'MANAGEMENT_TOOL.FEATURE_2_TITLE', textKey: 'MANAGEMENT_TOOL.FEATURE_2_TEXT' },
    { icon: 'lni-wallet', titleKey: 'MANAGEMENT_TOOL.FEATURE_3_TITLE', textKey: 'MANAGEMENT_TOOL.FEATURE_3_TEXT' },
    { icon: 'lni-bar-chart', titleKey: 'MANAGEMENT_TOOL.FEATURE_4_TITLE', textKey: 'MANAGEMENT_TOOL.FEATURE_4_TEXT' },
  ];

  readonly kpiSamples: KpiSample[] = [
    { labelKey: 'MANAGEMENT_TOOL.FEATURE_1_TITLE', value: '92%' },
    { labelKey: 'MANAGEMENT_TOOL.FEATURE_2_TITLE', value: '8.4%' },
    { labelKey: 'MANAGEMENT_TOOL.FEATURE_3_TITLE', value: '96%' },
  ];

  readonly relatedLinks: RelatedLink[] = [
    { route: '/calculators', icon: 'lni-calculator', titleKey: 'HOME.CALCULATORS_TITLE', textKey: 'HOME.CALCULATORS_TEXT_SHORT' },
    { route: '/documents', icon: 'lni-files', titleKey: 'HOME.DOCUMENTS_AND_TEMPLATES_TITLE', textKey: 'HOME.DOCUMENTS_AND_TEMPLATES_TEXT_SHORT' },
    { route: '/todo', icon: 'lni-checkbox', titleKey: 'HOME.TODO_LISTS_TITLE', textKey: 'HOME.TODO_LISTS_TEXT_SHORT' },
    { route: '/help', icon: 'lni-support', titleKey: 'HOME.HELP_CENTER_TITLE', textKey: 'HOME.HELP_CENTER_TEXT_SHORT' },
  ];

  constructor(
    public translate: TranslateService,
    private trackerService: TrackerService
  ) {}

  ngOnInit(): void {
    this.trackerService.trackPageViews();
    this.assistantHref = environment.assistantApp;
  }
}
